import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '../api/client.js';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (failureCount >= 2) return false;
        return error instanceof ApiError ? error.retryable : true;
      },
    },
    mutations: { retry: false },
  },
});
